import { Component, Input, OnInit } from '@angular/core';
import {
  DeliveryBillingForm,
  FormGroupTyped,
} from '../../../../core/types/interfaces';
import { TranslatePipe } from '@ngx-translate/core';
import { Profile } from '../../../models/profile.model';
import { TextFieldComponent } from '../../text-field/text-field.component';

@Component({
  selector: 'app-delivery-billing-info',
  templateUrl: './delivery-billing-info.component.html',
  styleUrls: ['./delivery-billing-info.component.scss'],
  imports: [TextFieldComponent, TranslatePipe],
})
export class DeliveryBillingInfoComponent {
  @Input() profile: Profile;
  @Input() formGroup: FormGroupTyped<DeliveryBillingForm>;
  @Input() isDelivery: boolean = false;

  constructor() {}
}
